/**
 *
 * Asynchronously loads the component for CatererDetail
 *
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
